<template>
    <div class="quiz__result quiz">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-xl-8 offset-xl-2">
                    <div class="result__text-wrapper d-flex  flex-column flex-lg-row">
                        <div class="result__text--guide">
                            <img src="@/assets/global/guide_happy.png" v-if="quizStatus == true" class="img-fluid">
                            <img src="@/assets/global/guide_sad.png" v-if="quizStatus == false" class="img-fluid">
                        </div>
                        <div>
                            <div class="result__text" v-if="attemptsLeft == 2 && quizStatus == false && user.quiz_active > 0">
                                <div class="result__text-headline" v-html="$t('QUIZ_RESULT01')">We're sorry</div>
                                <div class="text"><span v-html="$t('QUIZ_RESULT02')">Unfortunately you didn't reach enough points.<br>
                                    You reached</span> {{reachedPoints / maxPoints * 100}}% <span v-html="$t('QUIZ_RESULT03')">of the required</span> 80%
                                    <span v-html="$t('QUIZ_RESULT04')" v-if="pinInfo == 1"> in order to qualify for a Tokyo souvenir.</span>
                                    <span v-html="$t('QUIZ_RESULT04_NO_PIN')" v-if="pinInfo == 0"> in order to qualify for a Tokyo souvenir Pin.</span>
                                    <span v-if="worldName == 3" v-html="$t('QUIZ_RESULT04_EXTRA')">this time, but you did win one Discovery PIN.</span></div>
                                <div class="try__text" v-html="$t('QUIZ_RESULT05')" v-if="pinInfo == 1">You still got 2 more attempts left, please try again to get one special souvenir from your trip.</div>
                                <div class="try__text" v-html="$t('QUIZ_RESULT05_NO_PIN')" v-if="pinInfo == 0">You still got 2 more attempts left, please try again to get one special souvenir Pin from your trip.</div>
                                <div class="try__text" v-if="worldName == 1" v-html="$t('QUIZ_RESULT06')">If you need, browse Ginza again and discover once more the product information to pass the quiz !</div>
                                <div class="try__text" v-if="worldName == 2" v-html="$t('QUIZ_RESULT07')">If you need, browse Ueno Park again and discover once more the product information to pass the quiz !</div>
                                <div class="try__text" v-if="worldName == 3" v-html="$t('QUIZ_RESULT08')">If you need, browse Asakusa again and discover once more the product information to pass the quiz !</div>
                                <div class="result__btn--wrapper">
                                    <div class="try__again" v-on:click="tryAgain()" v-html="$t('QUIZ_RESULT10')">try again</div>
                                </div>
                            </div>

                            <div class="result__text" v-if="attemptsLeft == 1 && quizStatus == false && user.quiz_active > 0">
                                <div class="result__text-headline" v-html="$t('QUIZ_RESULT01')">We're sorry</div>
                                <div class="text"><span v-html="$t('QUIZ_RESULT02')">Unfortunately you didn't reach enough points.<br>
                                    You reached</span> {{reachedPoints / maxPoints * 100}}% <span v-html="$t('QUIZ_RESULT03')">of the required</span> 80%
                                    <span v-html="$t('QUIZ_RESULT04')" v-if="pinInfo == 1"> in order to qualify for a Tokyo souvenir.</span>
                                    <span v-html="$t('QUIZ_RESULT04_NO_PIN')" v-if="pinInfo == 0"> in order to qualify for a Tokyo souvenir.</span></div>
                                <div class="try__text" v-html="$t('QUIZ_RESULT11')" v-if="pinInfo == 1">You still got 1 more attempt left, please try again to get one special souvenir from your trip.<br>
                                    If you need, exit the quiz and discover the product information contained in this world again to pass the quiz.</div>
                                <div class="try__text" v-html="$t('QUIZ_RESULT11_NO_PIN')" v-if="pinInfo == 0">You still got 1 more attempt left, please try again to get one special souvenir Pin from your trip.<br>
                                    If you need, exit the quiz and discover the product information contained in this world again to pass the quiz.</div>
                                <div class="result__btn--wrapper">
                                    <div class="try__again" v-on:click="tryAgain()" v-html="$t('QUIZ_RESULT10')">try again</div>
                                </div>
                            </div>

                            <div class="result__text" v-if="attemptsLeft <= 0 && quizStatus == false && user.quiz_active > 0">
                                <div class="result__text-headline" v-html="$t('QUIZ_RESULT01')">We're sorry</div>
                                <div class="text"><span v-html="$t('QUIZ_RESULT02')">Unfortunatley you didnt reach enough points.<br>
                                You reached</span> {{reachedPoints / maxPoints * 100}}% <span v-html="$t('QUIZ_RESULT03')">of the required</span> 80%
                                    <span v-html="$t('QUIZ_RESULT12')" v-if="pinInfo == 1">in order to qualify for a Tokyo souvenir. Click on the button to see the correct answers.</span>
                                    <span v-html="$t('QUIZ_RESULT12_NO_PIN')" v-if="pinInfo == 0">in order to qualify for a Tokyo souvenir Pin. Click on the button to see the correct answers.</span></div>
                                <div class="result__btn--wrapper">
                                    <div class="correct__answer--btn" v-on:click="correctAnswers()" v-html="$t('GLOBAL_CORRECT')">correct answers</div>
                                </div>

                            </div>
                            <div class="result__text" v-if="quizStatus == false && user.quiz_active <= 0">
                                <div class="result__text-headline" v-html="$t('QUIZ_RESULT01')">We're sorry</div>
                                <div class="text"><span v-html="$t('QUIZ_RESULT02')">Unfortunatley you didnt reach enough points.<br>
                                You reached</span> {{reachedPoints / maxPoints * 100}}% <span v-html="$t('QUIZ_RESULT03')">of the required</span> 80%
                                    <span v-html="$t('QUIZ_RESULT22')" v-if="pinInfo == 1">in order to qualify for a Tokyo souvenir (unless you have already received it). Click on the button to see the correct answers.</span>
                                    <span v-html="$t('QUIZ_RESULT22_NO_PIN')" v-if="pinInfo == 0">in order to qualify for a Tokyo souvenir Pin (unless you have already received it). Click on the button to see the correct answers.</span></div>
                                <div class="result__btn--wrapper">
                                    <div class="try__again" v-on:click="tryAgain()" v-html="$t('QUIZ_RESULT10')">try again</div>
                                    <div class="correct__answer--btn" v-on:click="correctAnswers()" v-html="$t('GLOBAL_CORRECT')">correct answers</div>
                                </div>

                            </div>

                            <div class="result__text" v-if="(attemptsLeft >= 0 && quizStatus == true) || (user.gift_active <= 0 && quizStatus == true)">
                                <div class="result__text-headline" v-html="$t('QUIZ_RESULT13')">Congratulations</div>
                                <div class="text"><span v-html="$t('QUIZ_RESULT14')">You got</span> {{reachedPoints / maxPoints * 100}}%!</div>


                                <div class="text" v-if="worldName == 1" v-html="$t('QUIZ_RESULT15')">You have succeeded in the Ginza quiz and have collected a souvenir pin: <br></div>
                                <div class="text" v-else-if="worldName == 2" v-html="$t('QUIZ_RESULT16')">You have succeeded in the Ueno quiz and have collected a souvenir pin: <br></div>
                                <div class="text" v-else-if="worldName == 3" v-html="$t('QUIZ_RESULT17')">You have succeeded in the Asakusa quiz and have collected a souvenir pin: <br></div>
                                <div class="my-4 d-flex align-items-center justify-content-center">
                                    <span v-if="worldName == 1">
                                        <img src="@/assets/global/souvenir_01.png" class="img-fluid">
                                    </span>
                                    <span v-else-if="worldName == 2">
                                        <img src="@/assets/global/souvenir_02.png" class="img-fluid">
                                    </span>
                                    <span v-else-if="worldName == 3">
                                        <img src="@/assets/global/souvenir_03.png" class="img-fluid">
                                    </span>
                                </div>
                            </div>
                            <div class="result__navigation">
                                <div class="navigation__text">
                                    <span v-html="$t('QUIZ_RESULT18')" v-if="(quizStatus == true || attemptsLeft <= 0  || showAnswers == true)">What would you like to do next ? Move to the next district or stay longer in</span>
                                    <span v-if="worldName == 1 && user.user.language != 'RU' && user.user.language != 'IT' && (quizStatus == true || attemptsLeft <= 0  || showAnswers == true)">
                           Ginza?
                        </span>
                                    <span v-else-if="worldName == 2 && user.user.language != 'RU' && user.user.language != 'IT' && (quizStatus == true || attemptsLeft <= 0  || showAnswers == true)">
                            Ueno Park?
                        </span>
                                    <span v-else-if="worldName == 3 && user.user.language != 'RU' && user.user.language != 'IT' && (quizStatus == true || attemptsLeft <= 0  || showAnswers == true)">
                            Asakusa?
                        </span>
                                </div>
                                <div class="btns">
                                    <div class="btn__item btn__back text-center" v-on:click="backToWorld"><span v-html="$t('QUIZ_RESULT19')">browse</span>
                                        <span v-if="worldName == 1" v-html="$t('WORLD01_TEXT01')">
                           Ginza
                        </span>
                                        <span v-else-if="worldName == 2" v-html="$t('WORLD02_TEXT01')">
                            Ueno Park
                        </span>
                                        <span v-else-if="worldName == 3" v-html="$t('WORLD03_TEXT01')">
                            Asakusa
                        </span></div>
                                    <div class="btn__item btn__next text-center" v-if="(quizStatus == true || attemptsLeft <= 0  || showAnswers == true) && (worldName == 1 || worldName == 2)" v-on:click="nextChapter" v-html="$t('QUIZ_RESULT20')">next district</div>
                                    <div class="btn__item btn__next text-center" v-if="(quizStatus == true || attemptsLeft <= 0  || showAnswers == true) && (worldName == 3)" v-on:click="nextChapter" v-html="$t('QUIZ_RESULT21')">next</div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>

<!-- <div class="container-fluid">
    <div class="row">
        <div class="col-12 col-xl-8 offset-xl-2">
            <div class="result__navigation">
                <div class="navigation__text">
                    <span v-html="$t('QUIZ_RESULT18')" v-if="(quizStatus == true || attemptsLeft <= 0  || showAnswers == true)">What would you like to do next ? Move to the next district or stay longer in</span>
                    <span v-if="worldName == 1 && user.user.language != 'RU' && user.user.language != 'IT' && (quizStatus == true || attemptsLeft <= 0  || showAnswers == true)">
                           Ginza?
                        </span>
                    <span v-else-if="worldName == 2 && user.user.language != 'RU' && user.user.language != 'IT' && (quizStatus == true || attemptsLeft <= 0  || showAnswers == true)">
                            Ueno Park?
                        </span>
                    <span v-else-if="worldName == 3 && user.user.language != 'RU' && user.user.language != 'IT' && (quizStatus == true || attemptsLeft <= 0  || showAnswers == true)">
                            Asakusa?
                        </span>
                </div>
                <div class="btns">
                    <div class="btn__item btn__back text-center" v-on:click="backToWorld"><span v-html="$t('QUIZ_RESULT19')">browse</span>
                        <span v-if="worldName == 1" v-html="$t('WORLD01_TEXT01')">
                           Ginza
                        </span>
                        <span v-else-if="worldName == 2" v-html="$t('WORLD02_TEXT01')">
                            Ueno Park
                        </span>
                        <span v-else-if="worldName == 3" v-html="$t('WORLD03_TEXT01')">
                            Asakusa
                        </span></div>
                    <div class="btn__item btn__next text-center" v-if="(quizStatus == true || attemptsLeft <= 0  || showAnswers == true) && (worldName == 1 || worldName == 2)" v-on:click="nextChapter" v-html="$t('QUIZ_RESULT20')">next district</div>
                    <div class="btn__item btn__next text-center" v-if="(quizStatus == true || attemptsLeft <= 0  || showAnswers == true) && (worldName == 3)" v-on:click="nextChapter" v-html="$t('QUIZ_RESULT21')">next</div>
                </div>
            </div>
        </div>
    </div>
</div> -->

    </div>
</template>

<script>
    import lrsService from "@/services/lrsService";
    export default {
        name: "page-010-start",
        data: function () {
            return {
                worldName: Number,
                quizStatus: Boolean,
                attemptsLeft: Number,
                reachedPoints: Number,
                maxPoints: Number,
                showAnswers: Boolean,
                pinInfo: 1,
                user: ""
            }
        },
        methods:{
            correctAnswers(){
                if(this.worldName == 1){
                    this.$router.push({name: 'pages', params: { kapitel: '02', pageid: '010', showRightAnswers: true }});
                } else if(this.worldName == 2){
                    this.$router.push({name: 'pages', params: { kapitel: '02', pageid: '020', showRightAnswers: true }});
                } else if(this.worldName == 3){
                    this.$router.push({name: 'pages', params: { kapitel: '02', pageid: '030', showRightAnswers: true }});
                }

            },
            backToWorld(){
                if(this.worldName == 1){
                    this.$router.push({name: 'pages', params: { kapitel: '01', pageid: '010' }});
                } else if(this.worldName == 2){
                    this.$router.push({name: 'pages', params: { kapitel: '01', pageid: '020' }});
                } else if(this.worldName == 3){
                    this.$router.push({name: 'pages', params: { kapitel: '01', pageid: '030' }});
                }

            },
            nextChapter(){
                if(this.worldName == 1){
                    this.$router.push({name: 'pages', params: { kapitel: '01', pageid: '020' }});
                } else if(this.worldName == 2){
                    this.$router.push({name: 'pages', params: { kapitel: '01', pageid: '030' }});
                } else if(this.worldName == 3){
                    this.$router.push({name: 'pages', params: { kapitel: '02', pageid: '035' }});
                }
            },
            tryAgain(){
                if(this.worldName == 1){
                    this.$router.push({name: 'pages', params: { kapitel: '02', pageid: '010-start' }});
                } else if(this.worldName == 2){
                    this.$router.push({name: 'pages', params: { kapitel: '02', pageid: '020-start' }});
                } else if(this.worldName == 3){
                    this.$router.push({name: 'pages', params: { kapitel: '02', pageid: '030-start' }});
                }
            }
        },
        mounted() {
            this.attemptsLeft = this.$route.params.attemptsLeft;
            this.worldName = this.$route.params.worldName;
            this.quizStatus = this.$route.params.quizStatus;
            this.reachedPoints = this.$route.params.reachedPoints;
            this.maxPoints = this.$route.params.maxPoints;
            this.showAnswers = this.$route.params.showAnswers;

            this.pinInfo = this.$store.getters.seePinInfo;
            console.log((this.quizStatus == true || this.attemptsLeft <= 0  || this.showAnswers == true) && (this.worldName == 1 || this.worldName == 2))
            console.log((this.quizStatus == true ||this.attemptsLeft <= 0  || this.showAnswers == true))
            console.log( this.attemptsLeft)
            if(this.worldName == 1){
                if(this.quizStatus == true || this.attemptsLeft == 0){
                    lrsService.sendLRS('experienced', '01');
                    lrsService.sendLRS('progressed');
                }
            }
            if(this.worldName == 2){
                if(this.quizStatus == true || this.attemptsLeft == 0){
                    lrsService.sendLRS('experienced', '02');
                    lrsService.sendLRS('progressed');
                }
            }
            if(this.worldName == 3){
                if(this.quizStatus == true || this.attemptsLeft == 0){
                    lrsService.sendLRS('experienced', '03');
                    lrsService.sendLRS('progressed');

                }
            }
            let u = this.$store.getters.user;

            if (typeof u === 'string' || u instanceof String){
                u = JSON.parse(u)
            }
            this.user = u;
        },
        created() {
            this.$store.watch(
                (state, getters) => getters.user,
                (newValue, oldValue) => {
                    let u = this.$store.getters.user;
                    if (typeof u === 'string' || u instanceof String){
                        u = JSON.parse(u)
                    }
                    this.user = u;

                }
            )
        }
    }
</script>

<style scoped>

</style>